/* ÁGUAS DE IPANEMA — AUTOMATIC SHIPPING ELIGIBILITY RULE
   Sincroniza a mensagem de frete grátis (gaveta + página do carrinho) com a
   regra REAL do Shopify: consulta /cart/shipping_rates.json para o carrinho
   atual (CEP salvo do cliente, senão o CEP da loja como sonda da zona Brasil).
   Taxa de R$ 0 devolvida = frete grátis garantido no checkout → "ganhou".
   Sem taxa grátis: usa o mínimo da regra normal (Configurações do tema →
   Carrinho) só para dizer "faltam R$ X"; acima do mínimo sem taxa grátis =
   mensagem neutra (nunca contradiz o checkout). Recalcula em cart:updated /
   cart:refresh (add, quick add, remover, quantidade, bundle) sem reload. */
(function () {
  if (window.__aipFreteGratis) return;
  window.__aipFreteGratis = true;

  var CHAVE_CEP = 'aguas_shipping_postal_code', CHAVE_END = 'aguas_shipping_address';
  var cache = {};          /* assinatura do carrinho → { livre: bool } */
  var emCurso = null;      /* assinatura sendo sondada */
  var ultimoCarrinho = null;

  function ler(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function barras() { return document.querySelectorAll('[data-aip-frete]'); }

  /* PDP DYNAMIC SHIPPING CTA RULE: a PDP consome o MESMO estado (uma sonda, um
     cache). Quem quiser ouvir marca-se com [data-aip-frete-pdp] e escuta o
     evento aip:frete — nunca refaz a consulta nem recria a regra. */
  function consumidores() { return document.querySelectorAll('[data-aip-frete], [data-aip-frete-pdp]'); }
  var estadoAtual = null;

  function publicar(cart, livre) {
    var origem = document.querySelector('[data-aip-frete], [data-aip-frete-pdp]');
    estadoAtual = {
      livre: livre,                                   /* true | false | null (desconhecido) */
      cart: cart,
      subtotal: cart ? subtotalElegivel(cart) : 0,
      itens: cart ? cart.item_count : 0,
      minimo: origem ? (parseInt(origem.getAttribute('data-minimo'), 10) || 0) : 0,
      moeda: (origem && origem.getAttribute('data-moeda')) || (cart && cart.currency) || 'BRL'
    };
    try { document.dispatchEvent(new CustomEvent('aip:frete', { detail: estadoAtual })); } catch (e) {}
  }

  function moeda(cents, iso) {
    try { return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: iso || 'BRL' }).format(cents / 100); }
    catch (e) { return 'R$ ' + (cents / 100).toFixed(2).replace('.', ','); }
  }

  function subtotalElegivel(cart) {
    var s = cart.total_price;
    (cart.items || []).forEach(function (i) { if (i.requires_shipping === false) s -= i.final_line_price; });
    return Math.max(0, s);
  }

  function assinatura(cart) {
    return cart.total_price + '|' + (cart.items || []).map(function (i) { return i.variant_id + 'x' + i.quantity; }).join(',');
  }

  function enderecoSonda(barra) {
    var cep = (ler(CHAVE_CEP) || '').replace(/\D/g, '');
    var uf = '';
    try { var e = JSON.parse(ler(CHAVE_END) || 'null'); if (e && e.zip === cep) uf = e.province || ''; } catch (err) {}
    if (cep.length !== 8 || !uf) {
      /* sem CEP+UF do cliente: sonda com o endereço da loja (mesma zona Brasil) */
      cep = (barra.getAttribute('data-cep-loja') || '22750008').replace(/\D/g, '');
      uf = barra.getAttribute('data-uf-loja') || 'RJ';
    }
    return { zip: cep, province: uf, country: 'BR' };
  }

  function query(end) {
    return 'shipping_address%5Bzip%5D=' + encodeURIComponent(end.zip) + '&shipping_address%5Bcountry%5D=' + end.country + '&shipping_address%5Bprovince%5D=' + encodeURIComponent(end.province);
  }

  /* Devolve Promise<bool|null>: true = há taxa grátis; false = não há; null = não deu para saber */
  function sondar(end) {
    var q = query(end);
    var opts = { headers: { Accept: 'application/json' }, credentials: 'same-origin' };
    function ler(res) {
      return res.json().then(function (j) {
        var rates = (j && j.shipping_rates) || [];
        if (!rates.length && res.status !== 200) return null;
        return rates.some(function (r) { return parseFloat(r.price) === 0; });
      }).catch(function () { return null; });
    }
    return fetch('/cart/shipping_rates.json?' + q, opts).then(function (res) {
      if (res.status === 200) return ler(res);
      if (res.status === 202) {
        /* taxas de app (Frenet/Lalamove) ainda calculando: pede de novo */
        var tentativas = 0;
        return new Promise(function (resolve) {
          (function poll() {
            setTimeout(function () {
              fetch('/cart/async_shipping_rates.json?' + q, opts).then(function (r2) {
                if (r2.status === 200) return ler(r2).then(resolve);
                if (++tentativas < 6) poll(); else resolve(null);
              }).catch(function () { resolve(null); });
            }, 1000);
          })();
        });
      }
      return null;
    }).catch(function () { return null; });
  }

  function render(cart, livre) {
    var subtotal = subtotalElegivel(cart);
    barras().forEach(function (b) {
      var minimo = parseInt(b.getAttribute('data-minimo'), 10) || 0;
      var texto = b.querySelector('[data-aip-frete-texto]');
      var barra = b.querySelector('[data-aip-frete-barra]');
      var estado, msg, progresso;
      if (!cart.item_count) { b.hidden = true; return; }
      b.hidden = false;
      if (livre === true) {
        estado = 'ganhou';
        /* promoção geral (ganhou sem atingir o mínimo normal) tem texto próprio */
        /* estado conquistado — inclusive na promoção universal (item 14) */
        msg = b.getAttribute('data-msg-ganhou');
        progresso = 1;
      } else if (livre === false) {
        if (minimo > 0 && subtotal < minimo) {
          estado = 'falta';
          msg = (b.getAttribute('data-msg-falta') || '').replace('%s', moeda(minimo - subtotal, b.getAttribute('data-moeda')));
          progresso = Math.min(subtotal / minimo, 1);
        } else {
          estado = 'neutro'; msg = b.getAttribute('data-msg-neutro'); progresso = 0;
        }
      } else {
        /* sonda indisponível: fica com a regra normal (estado do servidor) */
        if (minimo > 0) {
          if (subtotal >= minimo) { estado = 'ganhou'; msg = b.getAttribute('data-msg-ganhou'); progresso = 1; }
          else { estado = 'falta'; msg = (b.getAttribute('data-msg-falta') || '').replace('%s', moeda(minimo - subtotal, b.getAttribute('data-moeda'))); progresso = Math.min(subtotal / minimo, 1); }
        } else { estado = 'neutro'; msg = b.getAttribute('data-msg-neutro'); progresso = 0; }
      }
      b.setAttribute('data-estado', estado);
      b.setAttribute('data-subtotal', subtotal);
      b.style.setProperty('--progress', progresso);
      if (texto) texto.innerHTML = msg;
      if (barra) { barra.hidden = (estado === 'neutro'); barra.setAttribute('aria-valuenow', Math.round(progresso * 100)); }
    });
    /* página do carrinho: linha "Frete: Grátis" no resumo */
    document.querySelectorAll('[data-aip-frete-linha]').forEach(function (l) { l.hidden = !(livre === true && cart.item_count > 0); });
    publicar(cart, livre);
  }

  function atualizar(cart) {
    var lista = consumidores();
    if (!lista.length) return;
    var pronto = cart ? Promise.resolve(cart) : fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
    pronto.then(function (c) {
      ultimoCarrinho = c;
      if (!c.item_count) { render(c, null); return; }
      var ass = assinatura(c);
      if (cache[ass]) { render(c, cache[ass].livre); return; }
      /* enquanto a sonda roda: com mínimo normal conhecido, mostra esse estado;
         sem mínimo (0) deixa o texto neutro do servidor — nunca promete antes da hora */
      var minimo0 = parseInt(lista[0].getAttribute('data-minimo'), 10) || 0;
      if (minimo0 > 0) render(c, null);
      if (emCurso === ass) return;
      emCurso = ass;
      sondar(enderecoSonda(lista[0])).then(function (livre) {
        if (emCurso === ass) emCurso = null;
        if (livre !== null) cache[ass] = { livre: livre };
        if (ultimoCarrinho && assinatura(ultimoCarrinho) === ass) render(ultimoCarrinho, livre);
      });
    }).catch(function () {});
  }

  /* eventos do tema e dos nossos quick adds */
  document.documentElement.addEventListener('cart:updated', function (e) { atualizar(e.detail && e.detail.cart); });
  document.documentElement.addEventListener('cart:refresh', function (e) {
    /* a gaveta é re-renderizada em seguida: espera o DOM novo */
    setTimeout(function () { atualizar(e.detail && e.detail.cart); }, 300);
  });
  /* CEP novo salvo pela calculadora → sonda de novo com o endereço do cliente */
  window.addEventListener('storage', function (e) { if (e.key === CHAVE_CEP) { cache = {}; atualizar(); } });
  document.addEventListener('aip:cep', function () { cache = {}; atualizar(); });

  /* gaveta/seção re-renderizada (sections API, Theme Editor) */
  if ('MutationObserver' in window) {
    var agendado = null;
    new MutationObserver(function (ms) {
      var toca = ms.some(function (m) { return Array.prototype.some.call(m.addedNodes, function (n) { return n.nodeType === 1 && (n.matches('[data-aip-frete]') || (n.querySelector && n.querySelector('[data-aip-frete]'))); }); });
      if (!toca) return;
      clearTimeout(agendado); agendado = setTimeout(function () { atualizar(); }, 50);
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  /* API mínima: recalcular do zero (ex.: após salvar CEP) e ler o último
     estado publicado (a PDP usa para pintar já na primeira renderização, sem
     precisar esperar o próximo evento). */
  window.aipFreteGratis = {
    recalcular: function () { cache = {}; emCurso = null; atualizar(); },
    estado: function () { return estadoAtual; }
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { atualizar(); });
  else atualizar();
})();
